 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {commitMutation} from 'react-relay'

import {AuthenticationError} from '../types/constEnums'


export var ForgotPasswordResType; (function (ForgotPasswordResType) {
  const GOOGLE = 'goog'; ForgotPasswordResType["GOOGLE"] = GOOGLE;
  const MICROSOFT = 'ms'; ForgotPasswordResType["MICROSOFT"] = MICROSOFT;
  const SAML = 'saml'; ForgotPasswordResType["SAML"] = SAML;
  const SUCCESS = 'success'; ForgotPasswordResType["SUCCESS"] = SUCCESS;
})(ForgotPasswordResType || (ForgotPasswordResType = {}));

const mutation = graphql`
  mutation EmailPasswordResetMutation($email: ID!) {
    emailPasswordReset(email: $email) {
      ... on ErrorPayload {
        error {
          message
        }
      }
    }
  }
`

const EmailPasswordResetMutation = (
  atmosphere,
  variables,
  {history, onError, onCompleted} = {}
) => {
  return commitMutation(atmosphere, {
    mutation,
    variables,
    onError,
    onCompleted: (res, err) => {
      if (onCompleted) onCompleted(res, err)
      const {email} = variables
      const params = new URLSearchParams()
      if (_optionalChain([res, 'access', _ => _.emailPasswordReset, 'optionalAccess', _2 => _2.error])) {
        const {message} = res.emailPasswordReset.error
        if (message === AuthenticationError.USER_EXISTS_GOOGLE) {
          params.set('type', ForgotPasswordResType.GOOGLE)
        } else if (message === AuthenticationError.USER_EXISTS_MICROSOFT) {
          params.set('type', ForgotPasswordResType.MICROSOFT)
        } else if (message === AuthenticationError.USER_EXISTS_SAML) {
          params.set('type', ForgotPasswordResType.SAML)
        } else return
      } else {
        params.set('type', ForgotPasswordResType.SUCCESS)
        params.set('email', email)
      }
      if (history) history.push(`/forgot-password/submitted?${params}`)
    }
  })
}

export default EmailPasswordResetMutation
